import { ITabItem, ITabsProps } from "./TabsTypes"

import { Flex, Image, Text, Center } from "@chakra-ui/react"
import { TabsContainer, TabItem } from "./StyledTabs"
import Icon from "components/UI/atoms/Icon"

const Tabs: React.FC<ITabsProps> = ({ items, currentTab, handleTabChange , width = "348" , height="58", renderOnlyIcons }) => {

  return (
    <TabsContainer  width={width} height={height}>
      <Flex alignItems="center" height="100%">
        {items.map(( item: ITabItem ) => (
          <TabItem 
            key={item.key}
            alignItems="center" 
            justifyContent="center" 
            height="100%" 
            width="50%"
            className={`${currentTab === item.key ? "active" : ""}`}
            onClick={()=>{
              handleTabChange(item.key)
            }}
            >
              {renderOnlyIcons && item.icon && <Image  src={item.icon} alt="Selected Language Flag" w="25px" h="25px"/>}
              {!renderOnlyIcons && item.value && (
                <Flex alignItems="center">
                  {item.valueIcon && currentTab === item.key && (
                    <Center w="30px" h="30px" borderRadius="50%" bg="white" mr="14px">
                      <Icon
                        name={item.valueIcon}
                        iconStyles={{ 
                          width: "12px", 
                          height: "12px", 
                          fill: "var(--chakra-colors-primary)"
                        }}
                        renderContent={item.renderContent}
                        content={item.content}
                      />
                    </Center>
                  )}
                  <Text>{item.value}</Text>
                </Flex>
              )}
            </TabItem>
        ))}
              </Flex>
    </TabsContainer>
  )
}

export default Tabs